// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"c29aa0bb","219":"ec96e64c","346":"c3ba322d","624":"2c3c52de","862":"e5836f0f","876":"ffc6e86b","915":"e05d0a4e"}[chunkId] + ".chunk.js";
};